import { COLORS } from "components/consts";

export const INITIAL_FORM_STATE = {
    category: '',
    kpi: '',
    types: '',
    subtypes: '',
    treatmentMethod: '',
    class: '',
    defaultUnit: '',
    description: '',
    includeCostData: false,
    defaultCurrency: 'USD'
} as const;

export const FIELD_STYLES = {
    menuItem: { fontSize: '14px' },
    select: { fontSize: '14px !important' },
    placeholder: { color: 'black', opacity: 0.25, fontSize: '12px', fontWeight: '500' },
    label: { color: COLORS.Mainblue },
    textField: {
        width: '100%',
        "& .MuiInputBase-root.MuiOutlinedInput-root": { fontSize: '12px', borderRadius: '8px' }
    },
    switchLabel: { color: COLORS.Mainblue, fontSize: '12px', fontWeight: '600' }
} as const;

export const LAYOUT_STYLES = {
    dialog: { maxWidth: "480px" },
    container: { display: "flex", flexDirection: "column", gap: "20px" },
    formContainer: { display: "flex", flexDirection: "column", gap: "15px" },
    gridContainer: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" },
    buttonContainer: { display: "flex", justifyContent: "flex-end", gap: "10px", mt: "20px" }
} as const;

export const TEXT_STYLES = {
    title: { color: COLORS.Mainblue, fontSize: '20px', fontWeight: '500' },
    stepTitle: { color: COLORS.Mainblue, fontSize: '12px', fontWeight: '600' }
} as const;
